export default {
  vipUpgrade: {
    title: 'Congratulation!!',
    message: 'You have been promoted from VIP{from} to VIP{to}',
    subtitle: 'Thank you for your support. Your new level brings\nexclusive services and special privileges.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
